<template>
  <div class="rdio rdio-primary">
    <input
      :id="id"
      ref="input"
      type="radio"
      :checked="checkValue"
      :disabled="disabled"
      :value="value"
      :name="name"
      :readonly="readonly"
      @change="setValue($event.target.value)"
    >
    <label :for="id" class="labelRadio">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "radio",
  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    value: {
      type: [String],
      default: "1"
    },
    checked: {
      type: [Number, String, Array],
      default: 1
    }
  },
  data() {
    return {
      id: Math.random()
        .toString(16)
        .slice(2)
    };
  },
  methods: {
    setValue(value) {
      this.$emit("update:checked", value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    checkValue() {
      return this.checked == this.value;
    }
  }
};
</script>

<style>
  .labelRadio {
    max-width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/Radio.vue